import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @jsx jsx */
import { jsx } from '@instructure/emotion';
import { DELETED_QUIZ_ENTRY, withStyleOverrides } from '@instructure/quiz-common';
import { Popover } from '@instructure/ui-popover';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { createBulkItems } from '../../../../../../building/api/items';
import { createBulkQuizEntries } from '../../../../../../building/api/quizEntries';
import { addAlert } from '../../../../../../common/actions/alerts';
import { connect } from '../../../../../../common/react-redux';
import CustomPropTypes from '../../../../../util/CustomPropTypes';
import { onPhone, onTablet } from '../../../../../util/windowChecks';
import AddContentBody from '../Body';
import AddContentButton from '../Button';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { quizGenerationButtonPropTypes } from '../Body/presenter';
function UnstyledAddContentPopover(_ref) {
  var _ref$allowStimulusCre = _ref.allowStimulusCreation,
    allowStimulusCreation = _ref$allowStimulusCre === void 0 ? true : _ref$allowStimulusCre,
    clearUi = _ref.clearUi,
    isEditing = _ref.isEditing,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? onPhone() || onTablet() : _ref$isMobile,
    openAddContentModal = _ref.openAddContentModal,
    _ref$parentEntryId = _ref.parentEntryId,
    parentEntryId = _ref$parentEntryId === void 0 ? null : _ref$parentEntryId,
    position = _ref.position,
    quizId = _ref.quizId,
    shouldFocus = _ref.shouldFocus,
    _ref$stimulusId = _ref.stimulusId,
    stimulusId = _ref$stimulusId === void 0 ? null : _ref$stimulusId,
    switchOffEditing = _ref.switchOffEditing,
    switchOnEditing = _ref.switchOnEditing,
    _ref$useStimulusTrigg = _ref.useStimulusTrigger,
    useStimulusTrigger = _ref$useStimulusTrigg === void 0 ? false : _ref$useStimulusTrigg,
    styles = _ref.styles,
    _ref$slotProps = _ref.slotProps,
    slotProps = _ref$slotProps === void 0 ? {} : _ref$slotProps;
  var popoverTrigger = useRef(null);
  useEffect(function () {
    if (shouldFocus) {
      setTimeout(function () {
        if (popoverTrigger.current) popoverTrigger.current.focus();
        clearUi(DELETED_QUIZ_ENTRY);
      }, 100);
    }
  }, [shouldFocus, clearUi]);
  function handleGenerateWithAiClick() {
    var _slotProps$quizGenera, _slotProps$quizGenera2;
    slotProps === null || slotProps === void 0 || (_slotProps$quizGenera = slotProps.quizGenerationButton) === null || _slotProps$quizGenera === void 0 || (_slotProps$quizGenera2 = _slotProps$quizGenera.onClick) === null || _slotProps$quizGenera2 === void 0 || _slotProps$quizGenera2.call(_slotProps$quizGenera);
    switchOffEditing();
  }
  var showContent = useCallback(function () {
    switchOnEditing();
  }, [switchOnEditing]);
  var hideContent = useCallback(function () {
    switchOffEditing();
  }, [switchOffEditing]);
  var storePopoverTriggerRef = useCallback(function (b) {
    popoverTrigger.current = b;
  }, []);
  var renderAddContentButton = function renderAddContentButton() {
    var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return jsx(AddContentButton, {
      ref: storePopoverTriggerRef,
      onClick: onClick,
      isEditing: isEditing,
      useStimulusTrigger: useStimulusTrigger
    });
  };
  var renderPopoverButton = function renderPopoverButton() {
    var _slotProps$quizGenera3;
    return jsx(Popover, {
      on: "click",
      placement: slotProps !== null && slotProps !== void 0 && (_slotProps$quizGenera3 = slotProps.quizGenerationButton) !== null && _slotProps$quizGenera3 !== void 0 && _slotProps$quizGenera3.visible ? 'end center' : 'bottom center',
      onShowContent: showContent,
      onHideContent: hideContent,
      isShowingContent: isEditing,
      shouldCloseOnEscape: true,
      shouldContainFocus: true,
      renderTrigger: renderAddContentButton()
    }, jsx(AddContentBody, {
      allowStimulusCreation: allowStimulusCreation,
      onOpenBankTray: switchOffEditing,
      onAddItem: switchOffEditing,
      parentEntryId: parentEntryId,
      position: position,
      quizId: quizId,
      stimulusId: stimulusId,
      slotProps: {
        quizGenerationButton: _objectSpread(_objectSpread({}, (slotProps === null || slotProps === void 0 ? void 0 : slotProps.quizGenerationButton) || {}), {}, {
          onClick: handleGenerateWithAiClick
        })
      }
    }));
  };
  var openAddContentModalHandler = useCallback(function () {
    openAddContentModal({
      allowStimulusCreation: allowStimulusCreation,
      parentEntryId: parentEntryId,
      position: position,
      quizId: quizId,
      stimulusId: stimulusId
    });
  }, [openAddContentModal, allowStimulusCreation, parentEntryId, position, quizId, stimulusId]);
  var renderModalButton = function renderModalButton() {
    return renderAddContentButton(openAddContentModalHandler);
  };
  var borderLine = useStimulusTrigger ? null : jsx("div", {
    css: styles.borderLine
  });
  var button = isMobile ? renderModalButton() : renderPopoverButton();
  return jsx("div", {
    css: styles.wrapper,
    "data-automation": "sdk-build-add-content"
  }, borderLine, button);
}
var AddContentPopoverWithStyles = withStyleOverrides(generateStyle, generateComponentTheme)(UnstyledAddContentPopover);
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addAlert: addAlert,
    createBulkItems: bindActionCreators(createBulkItems, dispatch),
    createBulkQuizEntries: bindActionCreators(createBulkQuizEntries, dispatch)
  };
};
export var AddContentPopover = connect(null, mapDispatchToProps)(AddContentPopoverWithStyles);
AddContentPopover.displayName = 'AddContentPopover';
AddContentPopover.componentId = "Quizzes".concat(AddContentPopover.displayName);
AddContentPopover.propTypes = {
  appContainer: CustomPropTypes.selectors.isRequired,
  allowStimulusCreation: PropTypes.bool,
  clearUi: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  openAddContentModal: PropTypes.func.isRequired,
  parentEntryId: PropTypes.string,
  position: PropTypes.number.isRequired,
  quizId: PropTypes.string.isRequired,
  shouldFocus: PropTypes.bool.isRequired,
  stimulusId: PropTypes.string,
  switchOffEditing: PropTypes.func.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  useStimulusTrigger: PropTypes.bool,
  styles: PropTypes.object,
  slotProps: PropTypes.shape({
    quizGenerationButton: quizGenerationButtonPropTypes
  })
};
export default AddContentPopover;